import { FILE_UNITS } from '@/fixtures/Constants'

export const convertFileSize = fileSize => {
  let unitIndex = 0
  let bytes = parseInt(fileSize, 10) || 0

  while (bytes >= 1024 && ++unitIndex) {
    bytes = bytes / 1024
  }

  return `${(bytes.toFixed(bytes < 10 && unitIndex > 0 ? 1 : 0))} ${FILE_UNITS[unitIndex]}`
}
